export default __webpack_public_path__ + "static/media/ico_arrow_left.df45c306.svg";